import { Component, OnInit } from '@angular/core';
import { AppInformationService, GenesisUnitOfWork } from 'app/core/core.module';
import { DealerTerm } from 'app/core/model/entity-model';
import { default as validationEngine } from 'devextreme/ui/validation_engine';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-dealer-term-dialog',
    templateUrl: './dealer-term-dialog.component.html',
    styleUrls: ['./dealer-term-dialog.component.scss'],
    standalone: false
})
export class DealerTermDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    dealerTerm: DealerTerm;
    displayOrder: number;
    validationGroup: 'dealerTermValidationGroup';

    constructor(
        public modalRef: BsModalRef,
        private uow: GenesisUnitOfWork,
        private appInfo: AppInformationService
    ) {}

    async ngOnInit() {
        await this.getData();
    }

    async getData() {
        if (!this.dealerTerm){
            this.dealerTerm = this.uow.dealerTerms.createEntity({
                created: new Date(),
                displayOrder: this.displayOrder
            }) as DealerTerm;
        }
    }

    async save() {
        if (!this.validate()) return;
        this.result.next({ success: true });
    }

    close() {
        this.uow.rollback();
        this.result.next({ success: false });
    }

    validate() {
        const groupConfig = validationEngine.getGroupConfig('dealerTermValidationGroup');
        if (groupConfig) {
            const result = validationEngine.validateGroup('dealerTermValidationGroup');
            if (!result.isValid) {
                let message = '';
                result.brokenRules.forEach((brokenRule) => {
                    if (brokenRule.type === 'custom') message = `${brokenRule.message}\n${message}`;
                });
                this.appInfo.notifyToast(`Please fix errors before saving.\n\n${message}`, 'error');
                return false;
            }
        }
        return true;
    }
}
